import * as React from 'react';
import { CreateEditingStyleInput } from '../../types';
import { isValidEditingStyleName, readName } from '../../editingStyleName';
import { readDescription } from '../../editingStyleDescription';

type UseCreateEditingStyleFormArgs = {
    onCreateSave: (input: CreateEditingStyleInput) => void;
    onClose: () => void;
};

type CreateEditingStyleFormState = {
    canCreate: boolean;
    handleChange: (event: React.FormEvent<HTMLFormElement>) => void;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
};

export function readInput(form: HTMLFormElement): CreateEditingStyleInput {
    let formData = new FormData(form);

    return {
        name: readName(formData.get('name')),
        description: readDescription(formData.get('description'))
    };
}

export function isCreatable(input: CreateEditingStyleInput): boolean {
    return isValidEditingStyleName(input.name);
}

export function useCreateEditingStyleForm({
    onCreateSave,
    onClose
}: UseCreateEditingStyleFormArgs): CreateEditingStyleFormState {
    const [canCreate, setCanCreate] = React.useState(false);
    const submitted = React.useRef(false);

    function handleChange(event: React.FormEvent<HTMLFormElement>) {
        setCanCreate(isCreatable(readInput(event.currentTarget)));
    }

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        if (submitted.current) {
            return;
        }

        submitted.current = true;
        onCreateSave(readInput(event.currentTarget));
        onClose();
    }

    return { canCreate, handleChange, handleSubmit };
}
